export default __webpack_public_path__ + "static/media/large_rectangle_336.beebf3c8.png";